import React, { useState, useEffect, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Text } from '@chakra-ui/react';
import { Editor } from 'react-draft-wysiwyg';
import { convertToRaw, ContentState, EditorState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import './textEditor.css';

// https://stackoverflow.com/questions/60106496/use-formik-on-react-draft-wysiwyg

function TextEditor({
  id,
  value,
  updateFieldValue,
  placeholder,
  errorMessage,
  refresh,
  updateRefresh,
}) {
  const [editorState, setEditorState] = useState(EditorState.createEmpty());

  useEffect(() => {
    if (!value || !refresh) {
      return;
    }

    const contentBlock = htmlToDraft(value);
    if (contentBlock) {
      const contentState = ContentState.createFromBlockArray(
        contentBlock.contentBlocks
      );
      const editorState = EditorState.createWithContent(contentState);
      setEditorState(editorState);
    }
    updateRefresh(false);
  }, [value]);

  const onEditorStateChange = (editorState) => {
    const forFormik = draftToHtml(
      convertToRaw(editorState.getCurrentContent())
    );
    updateFieldValue(forFormik);
    setEditorState(editorState);
  };

  return (
    <div>
      <Editor
        id={id}
        editorState={editorState}
        wrapperClassName="custom-wrapper"
        editorClassName="custom-editor"
        onEditorStateChange={onEditorStateChange}
        placeholder={placeholder}
        toolbar={{
          options: [
            'inline',
            'blockType',
            'fontSize',
            'fontFamily',
            'list',
            'textAlign',
            'link',
            'embedded',
            'remove',
            'history',
          ],
          link: { inDropdown: false },
        }}
      />
      <Text mt={8} color={'red'}>
        {errorMessage}
      </Text>
    </div>
  );
}

TextEditor.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  errorMessage: PropTypes.string,
  refresh: PropTypes.bool,
  updateFieldValue: PropTypes.func,
  updateRefresh: PropTypes.func,
};

export default forwardRef(TextEditor);
